'use strict'

const React = require('react')
const SuperAgent = require('superagent')
const classNames = require('classnames')
const DateHelper = require('../../../../../_plugins/lib/dateHelper')
const Helpers = require('../../../../../_plugins/lib/helpers')
const Tracker = require('../../../../../_plugins/lib/tracker')
const EngineHelper = require('../engines/engineHelper')
const propTypes = require('prop-types');
const { formSettings } = require('../../../../../config/')
const { string, func, number, instanceOf, bool } = propTypes
const createReactClass = require('create-react-class');

const FlightSearch = createReactClass({
  mixins: [DateHelper, EngineHelper, Helpers],

  propTypes: {
    name: string,
    activeFlight: string,
    placeHolder: string,
    cookieName: string,
    departure: instanceOf(Date),
    departureTime: string,
    departureTimeMax: number,
    departureTimeMin: number,
    returnTime: string,
    location: string,
    trackingPrefix: string,
    searchTimeout: number,
    minTextLimit: number,
    scrollResults: bool,
    terminal: string,
    autoFocus: bool,
    onChange: func,
    customChosenText: func,
    triggerFlightCodeInput: func,
    id: string,
    showFlightDropdown: bool
  },

  getDefaultProps () {
    return {
      activeFlight: '',
      placeHolder: 'Enter flight number, destination, airline or time',
      name: 'flight_number',
      cookieName: 'FlightNumber',
      searchTimeout: 300, // Default timeout before making search call
      minTextLimit: 3, // Min text length before making search
      trackingPrefix: 'flight_',
      showFlightDropdown: false
    }
  },

  getInitialState () {
    return {
      flights: [],
      showDropdown: false,
      flightNumber: this.props.activeFlight || null,
      flightText: null,
      lastRequest: false,
      interacted: false
    }
  },

  componentDidMount () {
    window.addEventListener('jQueryLoaded', this.forceUpdate())
    const { activeFlight } = this.props
    window._flightSearchDelay = window._flightSearchDelay || {}
    this.getFlight()
    this.focusInput()
  },

  componentWillUnmount () {
    window.removeEventListener('jQueryLoaded', this.forceUpdate())
  },

  shouldComponentUpdate (nextProps, nextState) {
    if (nextState.interacted === true && this.state.interacted === false) this.track('interacted')
    if (this.checkUpdated(nextState.flights, this.state.flights)) return true
    if (this.checkUpdated(nextState.flightText, this.state.flightText)) return true
    if (this.checkUpdated(nextState.flightNumber, this.state.flightNumber)) return true
    if (this.checkUpdated(nextState.showDropdown, this.state.showDropdown)) return true
    if (this.checkUpdated(nextState.lastRequest, this.state.lastRequest)) return true
    if (this.checkUpdated(nextState.chosenFlight, this.state.chosenFlight)) return true

    if (this.checkUpdated(nextProps.departure, this.props.departure)) return true
    if (this.checkUpdated(nextProps.departureTime, this.props.departureTime)) return true
    if (this.checkUpdated(nextProps.departureTimeMax, this.props.departureTimeMax)) return true
    if (this.checkUpdated(nextProps.departureTimeMin, this.props.departureTimeMin)) return true
    if (this.checkUpdated(nextProps.returnTime, this.props.returnTime)) return true
    if (this.checkUpdated(nextProps.location, this.props.location)) return true
    if (this.checkUpdated(nextProps.cookieName, this.props.cookieName)) return true
    if (this.checkUpdated(nextProps.trackingPrefix, this.props.trackingPrefix)) return true
    if (this.checkUpdated(nextProps.terminal, this.props.terminal)) return true
    if (this.checkUpdated(nextProps.showFlightDropdown, this.props.showFlightDropdown)) return true
    return false
  },

  componentDidUpdate (prevProps, prevState) {
    if (prevState.chosenFlight !== this.state.chosenFlight) this.reportBack()
    if (
      this.checkUpdated(prevProps.departure, this.props.departure) ||
      this.checkUpdated(prevProps.departureTime, this.props.departureTime) ||
      this.checkUpdated(prevProps.returnTime, this.props.returnTime) ||
      this.checkUpdated(prevProps.location, this.props.location) ||
      this.checkUpdated(prevProps.terminal, this.props.terminal) ||
      this.checkUpdated(prevProps.departureTimeMax, this.props.departureTimeMax) ||
      this.checkUpdated(prevProps.departureTimeMin, this.props.departureTimeMin)
    ) this.getFlight()

    this.shouldMakeSearch()
  },

  reportBack () {
    if (this.props.onChange) this.props.onChange(this.state.chosenFlight)
  },

  track (name, value = '1') {
    const { trackingPrefix } = this.props
    Tracker.inline(trackingPrefix + name, value)
  },

  focusInput () {
    const { autoFocus } = this.props
    if (!autoFocus) return
    const self = this
    setTimeout(() => {
      self.refs._flightInput.focus()
    }, 500)
  },

  clearText () {
    this.setState({
      interacted: true
    })
    this.resetFlight(true)
    this.track('cleared_text')
  },

  resetFlight (resetText = false) {
    const { cookieName } = this.props

    this.engineCookies(cookieName, '')
    this.setState({
      flights: [{
        flight: { code: 'TBC' },
        typeahead: 'No flights found'
      }],
      flightNumber: null,
      flightText: resetText ? null : this.state.flightText,
      lastRequest: resetText ? null : this.makeRequestURL('search')
    })
  },

  getFlight () {
    const { cookieName, searchTimeout, location, departure } = this.props
    let { activeFlight } = this.props
    const { flightNumber } = this.state
    if (flightNumber) activeFlight = flightNumber
    if (!this.typeaheadNotDropdown() || !activeFlight || !location || !departure) return

    this.clearTimer()
    window._flightSearchDelay[cookieName + 'flight'] = setTimeout(() => {
      SuperAgent
        .get(this.makeRequestURL('flight', true))
        .end(this.saveFlight)
    }, searchTimeout)
  },

  saveFlight (err, res) {
    const { customChosenText } = this.props
    this.clearTimer()
    if (err || !(res && res.body)) return this.resetFlight(true)
    const data = res.body
    if (!data.length || !data[0].flight) return this.resetFlight(true)
    let flightText = data[0].typeahead || ''
    if (customChosenText) {
      const customFlightText = customChosenText(data[0])
      if (customFlightText) flightText = customFlightText
    }
    this.setState({
      flightNumber: data[0].flight.code,
      flightText,
      flights: [],
      showDropdown: false
    })
  },

  handleKeyDown (e) {
    const { scrollResults } = this.props
    let highlighted = this.$('#flightSearch .dropdown-menu li.active')
    let nextHighlight = highlighted
    switch (e.keyCode) {
      case 27: // Escape key
        this.hideDropdown()
        e.preventDefault()
        e.stopPropagation()
        return false
      case 38:
      case 40:
        if (e.keyCode === 38) { // Up key
          if (highlighted) nextHighlight = highlighted.previousSibling
          if (!nextHighlight) nextHighlight = this.$('#flightSearch .dropdown-menu li:last-child')
        }
        if (e.keyCode === 40) { // Down key
          if (highlighted) nextHighlight = highlighted.nextSibling
          if (!nextHighlight) nextHighlight = this.$('#flightSearch .dropdown-menu li:first-child')
        }
        if (nextHighlight && highlighted !== nextHighlight) {
          if (highlighted) highlighted.classList.remove('active')
          nextHighlight.classList.add('active')
          if (scrollResults) this.scrollParentToChild(nextHighlight, e.keyCode === 40)
        }
        break
      case 13: // Enter key
        this.$('#flightSearch .dropdown-menu li.active a').click()
        e.preventDefault()
        e.stopPropagation()
        return false
    }
  },

  scrollParentToChild (child, down) {
    const parent = this.$('#flightSearch .dropdown-menu')
    const parentRect = parent.getBoundingClientRect()
    const parentHeight = parent.clientHeight

    const childRect = child.getBoundingClientRect()
    const isViewable = (childRect.top >= parentRect.top) && (childRect.bottom <= parentRect.bottom)

    // if you can't see the child try to scroll parent
    if (!isViewable) {
      if (down) parent.scrollTop = (childRect.top + parent.scrollTop) - parentHeight - child.clientHeight
      else parent.scrollTop = (childRect.top + parent.scrollTop) - parentRect.top
    }
  },

  handleSelectChange (e) {
    const { cookieName, triggerFlightCodeInput } = this.props
    const { flights } = this.state
    let { value, text } = e.target
    let flightIndex = 0
    const chosenFlight = flights.filter((f, key) => {
      if (f.flight.code === value) flightIndex = key

      return f.flight.code === value
    })
    if (triggerFlightCodeInput) triggerFlightCodeInput(value)
    this.engineCookies(cookieName, value)
    this.setState({
      flightText: text,
      chosenFlight: chosenFlight.length ? chosenFlight[0] : null,
      flightNumber: chosenFlight.length ? value : null,
      interacted: true,
      showDropdown: false
    })
    this.trackChosenFlight(value, flightIndex)
  },

  handleChange (e) {
    let { flightText, flightNumber } = this.state
    const { cookieName } = this.props
    const { value } = e.target
    if (this.notMeetingMinLengthRequirement(value) || (value !== flightText && flightText)) {
      flightNumber = null
      this.engineCookies(cookieName, '')
    }

    this.setState({
      flightText: value,
      flightNumber,
      interacted: true,
      showDropdown: !this.notMeetingMinLengthRequirement(value)
    })
  },

  terminalWithMinAndMax () {
    const { terminal, departureTimeMax, departureTimeMin } = this.props
    if ((departureTimeMax === 2400 || departureTimeMin === 0) && !this.typeaheadNotDropdown()) return true
    if (departureTimeMax && departureTimeMin && !this.typeaheadNotDropdown()) return true
    if (terminal && (departureTimeMax === 2400 || departureTimeMin === 0)) return true
    return terminal && departureTimeMax && departureTimeMin
  },

  shouldMakeSearch () {
    const { location, departure, cookieName } = this.props
    const { flightText, flightNumber, lastRequest } = this.state

    if (window._flightSearchDelay[cookieName + 'search']) return
    if (!location || !departure) return
    if (!flightText && !this.terminalWithMinAndMax()) return
    if (lastRequest === this.makeRequestURL('search')) return
    if (!this.typeaheadNotDropdown() && this.terminalWithMinAndMax()) return this.lookupFlights()
    if (flightNumber) return
    if (this.notMeetingMinLengthRequirement(flightText)) return
    this.lookupFlights()
  },

  notMeetingMinLengthRequirement (value) {
    const { minTextLimit } = this.props
    const valueLength = value ? value.replace(/\s?/, '').length : 0
    if (this.terminalWithMinAndMax()) {
      if (!value || valueLength >= 1) return false
    }
    if (!value) return true
    return valueLength < minTextLimit
  },

  clearTimer () {
    const { cookieName } = this.props
    clearInterval(window._flightSearchDelay[cookieName + 'search'])
    clearInterval(window._flightSearchDelay[cookieName + 'flight'])
    window._flightSearchDelay = {}
  },

  correctDate () {
    const { departure } = this.props
    return typeof departure === 'object' ? departure : new Date(departure)
  },

  makeRequestURL (type, track = false) {
    const { location, departureTimeMin, terminal } = this.props
    let { activeFlight, departureTime, returnTime, departureTimeMax } = this.props
    let { flightText = '', flightNumber } = this.state
    if (!flightText || !this.typeaheadNotDropdown()) flightText = ''
    if (flightNumber) activeFlight = flightNumber
    const departure = this.correctDate()
    const query = type === 'flight' ? 'flight=' + activeFlight : 'query=' + flightText
    const url = [
      formSettings.flightSearch + type + '?' + query,
      'location=' + location,
      'departDate=' + this.nativeDateToIso(departure)
    ]
    if (terminal && this.typeaheadNotDropdown()) url.push('terminal=' + terminal)
    if (!this.typeaheadNotDropdown()) url.push('noCodeShares=1')
    if (type !== 'flight' && departureTime) {
      if (departureTimeMin) departureTime = this.pad(Number(departureTime) + departureTimeMin, 4)
      if (departureTimeMax) {
        departureTimeMax = this.pad(Number(departureTime) + departureTimeMax, 4)
        if (Number(departureTimeMax.toString().slice(-2)) >= 60) {
          departureTimeMax -= Number(departureTimeMax.toString().slice(-2)) - 100
        }
        url.push('departTimeMax=' + departureTimeMax)
      }
      url.push('departTime=' + departureTime)
      url.push('returnTime=' + (returnTime || '2359'))
    }
    if (track) {
      this.track('searching', {
        type,
        query,
        location,
        departDate: this.nativeDateToIso(departure)
      })
    }
    return url.join('&')
  },

  searching () {
    const { triggerFlightCodeInput } = this.props
    const { lastRequest } = this.state

    if (triggerFlightCodeInput && lastRequest) { // lastRequest is false initially, can use to check if already requested or just loaded
      triggerFlightCodeInput('undefined') // make the input go away, since this is a new search
    }
    this.setState({
      flights: [{
        flight: { code: 'SEARCHING' },
        typeahead: 'Searching for flights...'
      }]
    })
  },

  lookupFlights () {
    const { cookieName, searchTimeout } = this.props
    const { flightText } = this.state

    if (!flightText && !this.terminalWithMinAndMax()) return this.resetFlight()
    this.searching()

    this.clearTimer()
    window._flightSearchDelay[cookieName + 'search'] = setTimeout(() => {
      SuperAgent
        .get(this.makeRequestURL('search', true))
        .end(this.showResults)
    }, searchTimeout)
  },

  showResults (err, res) {
    this.clearTimer()
    if (err || !(res && res.body)) return this.resetFlight()
    const data = res.body
    if (!data.length) return this.resetFlight()

    this.setState({
      flights: data,
      lastRequest: this.makeRequestURL('search')
    })
  },

  handleClick (e) {
    const { cookieName, customChosenText } = this.props
    const { flights } = this.state
    const flightNumber = e.target.getAttribute('data-flight')
    const flightIndex = e.target.getAttribute('data-flight-index')
    let flightText = flightNumber
    if (customChosenText) {
      const customFlightText = customChosenText(flights[flightIndex])
      if (customFlightText) flightText = customFlightText
    }
    this.engineCookies(cookieName, flightNumber)
    const chosenFlight = flights.filter(f => f.flight.code === flightNumber)
    this.setState({
      flightNumber,
      chosenFlight: chosenFlight.length ? chosenFlight[0] : null,
      flightText,
      showDropdown: false
    })
    this.trackChosenFlight(flightNumber, flightIndex)
    e.preventDefault()
    return false
  },

  trackChosenFlight (flightNumber, flightIndex) {
    const { flights } = this.state
    if (!flightNumber) this.track('cant_find_flight')
    else if (flightNumber === 'flight_not_listed' || flightNumber === 'flight_or_incorrect' || flightNumber === 'flight_unknown') {
      this.track(flightNumber)
    } else {
      this.track('total_and_chosen_position', flights.length + ' - ' + flightIndex)
      this.track('chosen', flightNumber)
    }
  },

  showDropdown () {
    setTimeout(() => {
      this.setState({
        showDropdown: true
      })
    }, 100)
  },

  blurDropdown () {
    setTimeout(() => {
      this.setState({
        showDropdown: false
      })
    }, 100)
  },

  hideDropdown () {
    this.setState({
      showDropdown: false
    })
  },

  interactedWith () {
    this.setState({
      interacted: true
    })
  },

  makeFlightTypeahead () {
    const { flights } = this.state
    return (
      <div className='dropdown-menu' onFocus={this.showDropdown}>
        <ul>
          { flights.map((flight, key) => (
            <li key={key}>
              <a data-flight-index={key} data-flight={flight.flight.code} href='#' onClick={this.handleClick}>{flight.typeahead}</a>
            </li>
          ))}
        </ul>
      </div>
    )
  },

  haveFlights () {
    const { flightText, showDropdown, flightNumber, flights } = this.state
    if (this.notMeetingMinLengthRequirement(flightText)) return false
    return flights.length > 0 && showDropdown && !flightNumber
  },

  typeaheadNotDropdown () {
    return !this.props.showFlightDropdown
  },

  generateFlightInput () {
    const { name, placeHolder, id } = this.props
    let { flightText, flights, flightNumber } = this.state
    let searching = false
    if (this.typeaheadNotDropdown()) {
      return (
        <input ref='_flightInput' autoComplete={'off'} id={id} className='form-control' name={name + '_text'} type='text' value={flightText} onClick={this.showDropdown} onBlur={this.blurDropdown} onFocus={this.showDropdown} placeholder={placeHolder} onKeyDown={this.handleKeyDown} onChange={this.handleChange} />
      )
    }
    // Dropdown doesn't need the resetFlight option
    if (flights.length && flights[0].flight.code === 'TBC') {
      flights = []
    }
    if (flights.length && flights[0].flight.code === 'SEARCHING') {
      flights = []
      searching = true
    }
    return (
      <select onClick={this.interactedWith} onChange={this.handleSelectChange} value={flightNumber} name={name} ref='_flightInput' className='form-control'>
        { searching && (
          <option value=''>Searching...</option>
        )}
        { flights.length > 0 && (
          <option value='TBC'>{`${placeHolder} (${flights.length})`}</option>
        )}
        { !flights.length && flightNumber && flightText && !searching && (
          <option value={flightNumber}>{flightText}</option>
        )}
        { !flights.length && !flightNumber && !searching && (
          <option value='TBC'>No flights found</option>
        )}
        { flights.length > 0 && this.createDropdownOptions()}
        { flights.length > 0 && (
          <option value='flight_unknown'>Don't know my flight</option>
        )}
        { flights.length > 0 && (
          <option value='flight_inline_donthaveit'>Don’t have it to hand</option>
        )}
        { flights.length > 0 && (
          <option value='flight_not_listed'>Flight not listed</option>
        )}
        { flights.length > 0 && (
          <option value='flight_incorrect'>Flight incorrect</option>
        )}
      </select>
    )
  },

  createDropdownOptions () {
    let { terminal } = this.props
    let { flights, flightNumber } = this.state
    if (!flights.length) return null
    let terminals = {}
    flights
      .filter(i => i && i.departure)
      .map((flight, key) => {
        if (!flight || !flight.departure) return
        const flightTerminal = (terminal || !flight.departure.terminal) ? '' : ' (Terminal ' + flight.departure.terminal + ')'
        const element = (
          <option key={key} selected={flight.flight.code === flightNumber} value={flight.flight.code}>{flight.departure.time + ' to ' + (flight.arrival.city === 'London' ? flight.arrival.airport : flight.arrival.city)}{flightTerminal}</option>
      )
        if (!terminals[terminal ? flight.departure.terminal : '']) terminals[terminal && flight.departure.terminal ? flight.departure.terminal : ''] = []
        terminals[terminal && flight.departure.terminal ? flight.departure.terminal : ''].push(element)
      })
    if (!terminal) return terminals['']
    terminal = terminal + ''
    const output = []
    const currentTerminal = terminals[terminal]
    delete terminals[terminal]
    const element = (
      <optgroup key={terminal} label={`Terminal ${terminal}`}>
        {currentTerminal}
      </optgroup>
    )
    output.push(element)
    Object.keys(terminals).map(key => {
      const term = terminals[key]
      if (!key) key = 'Unknown'
      const element = (
        <optgroup key={key} label={`Terminal ${key}`}>
          {term}
        </optgroup>
      )
      output.push(element)
    })
    return output
  },

  render () {
    const { showFlightDropdown } = this.props
    const { flightText } = this.state
    const flightResults = this.makeFlightTypeahead()
    const shouldShowResults = flightResults && this.haveFlights() && this.typeaheadNotDropdown()
    const containerClass = classNames({
      'open': shouldShowResults,
      'hideLabelSplitTest': showFlightDropdown
    })
    const flightInput = this.generateFlightInput()

    return (
      <div className={containerClass} id='flightSearch'>
        { flightInput }
        { shouldShowResults && flightResults }
        { this.typeaheadNotDropdown() && flightText && (
          <span onClick={this.clearText} className='btn-clear-flight'>x</span>
        )}
      </div>
    )
  }
})

module.exports = FlightSearch





// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/flight-lookup/flight-search.jsx